import { EXPIRY_MONTHS, type ExpiryMonths } from './constants';

export const isExpiryMonths = (value: unknown): value is ExpiryMonths =>
  typeof value === 'number' &&
  (EXPIRY_MONTHS as readonly number[]).includes(value);

export const computeExpiresAt = (
  submittedAt: string,
  expiryMonths: ExpiryMonths,
): string => {
  const submitted = new Date(submittedAt);
  const expires = new Date(submitted);
  expires.setUTCMonth(expires.getUTCMonth() + expiryMonths);
  return expires.toISOString();
};

/** Listings without `expiresAt` are grandfathered and never expire. */
export const isListingExpired = (
  expiresAt: string | undefined,
  now: Date = new Date(),
): boolean => {
  if (!expiresAt) {
    return false;
  }
  return new Date(expiresAt).getTime() <= now.getTime();
};
